// calls f if event contains and escape or enter key
export const handleKeyPress = f => event => {
  if (event.charCode === 32 || event.charCode === 13) {
    f();
  }
};
